<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <title>Download</title>
    <path
      d="M8,15.85c-1.059,0-2.086-.207-3.055-.616-.933-.396-1.773-.961-2.496-1.683-.72-.721-1.286-1.56-1.682-2.495-.41-.97-.617-1.997-.617-3.056s.208-2.086.617-3.055c.395-.934.961-1.774,1.682-2.496.719-.719,1.559-1.285,2.496-1.682.969-.41,1.997-.617,3.055-.617s2.086.208,3.056.617c.934.395,1.773.961,2.496,1.682.72.722,1.285,1.561,1.682,2.496.409.969.616,1.997.616,3.055s-.207,2.086-.617,3.056c-.395.933-.96,1.772-1.682,2.496-.721.72-1.561,1.286-2.495,1.682-.97.409-1.997.616-3.056.616ZM8,1.305c-3.691,0-6.695,3.003-6.695,6.695s3.003,6.695,6.695,6.695,6.695-3.004,6.695-6.695S11.691,1.305,8,1.305ZM7.967,11.484c-.067-.004-.12-.016-.168-.035-.079-.029-.148-.074-.208-.133l-2.908-2.908c-.225-.226-.225-.592,0-.817.109-.109.254-.169.408-.169s.3.06.409.169l1.924,1.924v-4.425c0-.318.259-.577.577-.577s.577.259.577.577v4.425l1.924-1.925c.108-.109.254-.169.408-.169s.3.06.408.169c.226.226.226.592,0,.817l-2.908,2.908c-.059.059-.127.104-.205.132-.053.021-.107.032-.162.036h-.043s-.033,0-.033,0Z"
      fill="#000"
    />
  </svg>
</template>

<script>
export default {};
</script>
